export default "__VITE_ASSET__CHbY1Oq4__"